import { useCallback, useEffect, useState } from 'react';
import { SearchModality } from '../feature/search-table-company/hooks/types';
import { useSearchModality } from './use-search-modality';

export function useSearchTableTabs() {
  const { modality, setModality } = useSearchModality();

  const [tab, setTab] = useState<string>(modality ?? SearchModality.TOTAL);

  useEffect(() => {
    if (modality && modality !== tab) {
      setTab(modality);
    }
  }, [modality, tab]);

  const handleChangeTab = useCallback(
    (_e: React.SyntheticEvent, v: string) => {
      setModality(v as SearchModality);
    },
    [setModality]
  );

  return { tab, setTab, handleChangeTab };
}
